import { render, staticRenderFns } from "./AreYouSure.vue?vue&type=template&id=524db8be&scoped=true&"
import script from "./AreYouSure.vue?vue&type=script&lang=js&"
export * from "./AreYouSure.vue?vue&type=script&lang=js&"
import style0 from "./AreYouSure.vue?vue&type=style&index=0&id=524db8be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524db8be",
  null
  
)

export default component.exports